module.exports = __webpack_public_path__ + "static/opera-sponsor-80a2a287d9dbb6f04f70d55227f286b4.png";